<template>
    <el-aside :class="this.$store.state.sideCollapse?'ui-side ui-side-narrow':'ui-side'">
        <div class="ui-side-logo">
            <img src="../../assets/logo.png">
            <span>{{ this.$title }}</span>
        </div>
        <div class="ui-side-main">
            <el-scrollbar>
                <el-menu router :default-active="this.$store.state.pageActive" :collapse="this.$store.state.sideCollapse" mode="vertical" >
                    <template v-for="side_one in sideData">
                        <el-submenu v-if="side_one.children" :index="side_one.path" :key="side_one.path">
                            <template #title>
                                <i :class="side_one.icon"></i>
                                <span>{{ side_one.name }}</span>
                            </template>
                            <el-menu-item-group>
                                <el-menu-item v-for="side_two in side_one.children" :index="side_one.path+side_two.path" :key="side_two.path">{{ side_two.name }}</el-menu-item>
                            </el-menu-item-group>
                        </el-submenu>
                        <el-menu-item v-else :index="side_one.path" :key="side_one.path"><i :class="side_one.icon"></i>
                            <template #title>{{ side_one.name }}</template>
                        </el-menu-item>
                    </template>
                </el-menu>
            </el-scrollbar>
        </div>
    </el-aside>
</template>

<script>
    export default {
        name: "side",
        data() {
            return {
                // 01.01.侧边栏数组
                sideData: [],
            }
        },
        // 方法集合
        methods: {
            // 01.获取侧边栏数组
            getSide() {
                this.$api.get('/api/get/side-tree/', {'code': 'Central'}).then((response) => {
                    this.sideData = response.data
                })
            }
        },
        // 生命周期 - 挂载完成
        mounted() {
            // 01.获取侧边栏数组
            this.getSide()
        },
    }
</script>
